import { useEffect, Component } from "react";
import "@/App.css";
import Lenis from "lenis";
import Nav from "@/landing/Nav";
import Hero from "@/landing/Hero";
import Marquee from "@/landing/Marquee";
import Sets from "@/landing/Sets";
import Included from "@/landing/Included";
import Reviews from "@/landing/Reviews";
import Faq from "@/landing/Faq";
import MapSection from "@/landing/MapSection";
import { FinalCta, Footer, StickyMobileBar } from "@/landing/FinalCta";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        console.error("Landing page error:", error);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-pine-950 px-6 text-center">
                    <div>
                        <h1 className="font-serif text-3xl text-cream">Something went wrong</h1>
                        <p className="mt-3 text-mist">Please refresh the page to see our Christmas sessions.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ anchors: true, duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="grain relative min-h-screen bg-pine-950 pb-20 md:pb-0">
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <Sets />
                    <Included />
                    <Reviews />
                    <Faq />
                    <MapSection />
                    <FinalCta />
                </main>
                <Footer />
                <StickyMobileBar />
            </div>
        </ErrorBoundary>
    );
}

export default App;
